import { getApiAsync } from '../api/apiClient';
import type { NotificationServerSync } from './NotificationStore';
import type { RootStore } from './RootStore';

/**
 * Leer, marcar todos como leídos y quitar (la X) un aviso que el server guardó
 * (UserNotification) llegan al server, con las mutaciones de
 * common/schemas/notifications.graphql. Lo usa NotificationStore, que cambia la
 * campana en el momento y, si esto falla, lo loguea y sigue.
 *
 * Solo en los proyectos con el contrato de avisos (la entidad UserNotification):
 * sin ella el server no tiene dónde marcar nada, y el generador no copia este
 * archivo ni el .graphql, ni el RootStore lo usa.
 */
export function notificationServerSync(rootStore: RootStore): NotificationServerSync {
  const api = () => getApiAsync(rootStore.authStore, rootStore.activityStore);
  return {
    async markRead(userNotificationId) {
      const result = await (await api()).markNotificationRead({ id: userNotificationId });
      throwIfNotDone('markNotificationRead', result?.markNotificationRead);
    },
    async markAllRead() {
      const result = await (await api()).markAllNotificationsRead();
      if (typeof result?.markAllNotificationsRead !== 'number') {
        throw new Error('markAllNotificationsRead: no answer');
      }
    },
    async archive(userNotificationId) {
      const result = await (await api()).archiveNotification({ id: userNotificationId });
      throwIfNotDone('archiveNotification', result?.archiveNotification);
    },
  };
}

/**
 * Lo que no cuenta como hecho tira, para que NotificationStore lo loguee: el
 * server contesta success: false, sin tirar, cuando no encuentra el aviso entre
 * los del usuario, y el wrapper de la api devuelve undefined, sin tirar, cuando
 * el pedido se cancela (un pedido de este tipo se puede cancelar a mano).
 */
function throwIfNotDone(operation: string, answer: { success: boolean; error?: string | null } | undefined): void {
  if (!answer) {
    throw new Error(`${operation}: no answer`);
  }
  if (!answer.success) {
    throw new Error(`${operation}: ${answer.error || 'success: false'}`);
  }
}
